import type { LocaleType } from "@crescentapplications/react-ui";

const imageAltsLocales: LocaleType = {
  ahmadIrvine: {
    ar: "الإمام أحمد خارج منزله السابق بمدينة إيرڤاين بولاية كاليفورنيا",
    en: "Imam Ahmad outside his previous home in Irvine, CA",
  },
  madinahMosque: {
    ar: "المسجد النبوي الشريف في المدينة المنورة",
    en: "Madinah mosque",
  },
  ahmadGrayBg: {
    ar: "الإمام أحمد",
    en: "Imam Ahmad",
  },
  ahmadConstruction: {
    ar: "الإمام أحمد أثناء إنشاء مدرسة الرؤية الجديدة الدولية",
    en: "Imam Ahmad while building New Vision International School",
  },
  ahmadOffice: {
    ar: "الإمام أحمد في مكتبه السابق في أكاديمية الهلال بمدينة إيرڤاين",
    en: "Imam Ahmad at his previous office in Irvine, CA",
  },
};

export default imageAltsLocales;
